export default function EducationCard({
  date,
  degree,
  institution,
  period,
  location,
  level,
  isLast,
}) {
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const filtered_date =
    month[new Date(date).getMonth()] + " " + new Date(date).getFullYear();

  return (
    <div className="relative pl-10">
      <span
        className={`absolute left-0 top-0 w-px bg-gradient-to-b from-[#D4AF6A]/70 to-[#D4AF6A]/0 ${
          isLast ? "h-8" : "h-full"
        }`}
      />
      <span className="pulse-node absolute -left-[5px] top-1.5 w-[11px] h-[11px] rounded-full bg-[#D4AF6A]" />

      <div className="hover-glow bg-white/[0.02] border border-white/5 rounded-lg p-6 mb-8">
        <p className="text-xs tracking-widest uppercase text-[#D4AF6A] mb-2">
          {filtered_date}
        </p>
        <h3 className="font-display text-2xl mb-1">{degree}</h3>
        <p className="text-sm text-[#93A894] mb-3">{level}</p>
        <p className="text-[#D9D2C2]">{institution}</p>
        <p className="text-sm text-[#93A894]">
          {period} · {location}
        </p>
      </div>
    </div>
  );
}
